import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tag } from 'primereact/tag'
import {
  faBus,
  faCar,
  faMotorcycle,
  faPerson,
  faTruck,
} from '@fortawesome/free-solid-svg-icons'

export const getVehicleType = (vehicleType: string) => {
  switch (vehicleType) {
    case 'cars':
      return (
        <Tag
          severity='info'
          value={
            <>
              <FontAwesomeIcon
                icon={faCar}
                size='xl'
                className='mr-1'
              />{' '}
              Carro
            </>
          }
        ></Tag>
      )
    case 'bikes':
      return (
        <Tag
          severity='info'
          value={
            <>
              <FontAwesomeIcon
                icon={faMotorcycle}
                size='xl'
                className='mr-1'
              />{' '}
              Moto
            </>
          }
        ></Tag>
      )
    case 'trucks':
      return (
        <Tag
          severity='info'
          value={
            <>
              <FontAwesomeIcon
                icon={faTruck}
                size='xl'
                className='mr-1'
              />{' '}
              Caminhão
            </>
          }
        ></Tag>
      )
    case 'buses':
      return (
        <Tag
          severity='info'
          value={
            <>
              <FontAwesomeIcon
                icon={faBus}
                size='xl'
                className='mr-1'
              />{' '}
              Ônibus
            </>
          }
        ></Tag>
      )
    case 'people':
      return (
        <Tag
          severity='info'
          value={
            <>
              <FontAwesomeIcon
                icon={faPerson}
                size='xl'
                className='mr-1'
              />{' '}
              Pessoa
            </>
          }
        ></Tag>
      )
  }
}
